import {
  BASE_URL,
  GUEST_SESSION_ID,
  MSME_USER_ID,
  MSME_USER_TOKEN,
  MSME_USER_TYPE,
} from "../../utils/Constants";
import { getCookie, removeCookie, storeCookie } from "../../utils/CookieAction";

export const CLEAN_ACCOUNT_EXISTANCE = "CLEAN_ACCOUNT_EXISTANCE";

export const ACCOUNT_EXISTANCE = "ACCOUNT_EXISTANCE";

export const AUTHENTICATION = "AUTHENTICATION";

export const AUTH = "AUTH";

export const NETWORK_REGISTRATION = "NETWORK_REGISTRATION";

export const REGISTRATION = "REGISTRATION";

export const STORE_CITY = "STORE_CITY";

export const STORE_SEARCH = "STORE_SEARCH";

export const DDC_REGISTRATION = "DDC_REGISTRATION";

export const MSME_REGISTRATION = "MSME_REGISTRATION";

export const LOGOUT = "LOGOUT";

export const GET_CODE = "GET_CODE";

export const accountExistAnce = (phoneNumber) => {
  return async (dispatch) => {
    const response = await fetch(`${BASE_URL}account/existAnce`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ phoneNumber }),
    });

    if (!response.ok) {
      const result = await response.json();
      throw new Error(result.msg);
    }

    const result = await response.json();

    if (result.status) {
      dispatch({
        type: ACCOUNT_EXISTANCE,
        data: result.msg,
      });
    } else {
      throw new Error(result.msg);
    }
  };
};

export const register = ({
  name,
  businessName,
  gstNo,
  mobile,
  email,
  password,
  state,
  district,
  pincode,
  address,
  canteen_type,
  canteen_code,
}) => {
  return async (dispatch) => {
    const guest_session_id = getCookie(GUEST_SESSION_ID);

    let guestSessionId = null;

    if (guest_session_id) {
      guestSessionId = JSON.parse(guest_session_id);
    }

    const response = await fetch(`${BASE_URL}account/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        name_of_entity: businessName,
        gst_no: gstNo,
        mobile,
        email,
        password,
        state,
        district,
        pincode,
        address,
        session_id: guestSessionId,
        canteen_type,
        canteen_code,
      }),
    });

    if (!response.ok) {
      const result = await response.json();
      throw new Error(result.msg);
    }

    const result = await response.json();

    if (result.status) {
      dispatch({
        type: AUTHENTICATION,
      });
      dispatch(auth(result.data.token));
      await saveToken(result.data.token, result.data.id);
    } else {
      throw new Error(result.msg);
    }
  };
};

export const login = (phone, password) => {
  return async (dispatch) => {
    const guest_session_id = getCookie(GUEST_SESSION_ID);

    let guestSessionId = null;

    if (guest_session_id) {
      guestSessionId = JSON.parse(guest_session_id);
    }

    const response = await fetch(`${BASE_URL}account/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        mobile: phone,
        password,
        session_id: guestSessionId,
      }),
    });

    if (!response.ok) {
      const result = await response.json();
      throw new Error(result.msg);
    }

    const result = await response.json();

    if (result.status) {
      dispatch({
        type: AUTHENTICATION,
      });
      dispatch(auth(result.data.token));
      await saveToken(result.data.token, result.data.id);
    } else {
      throw new Error(result.msg);
    }
  };
};

export const auth = (accessToken) => {
  return {
    type: AUTH,
    accessToken: accessToken,
  };
};

export const saveToken = async (accessToken, userType, userId) => {
  await storeCookie(MSME_USER_TOKEN, JSON.stringify(accessToken));
  await storeCookie(MSME_USER_TYPE, JSON.stringify(userType));
  await storeCookie(MSME_USER_ID, userId);
};

export const cleanExistAnce = () => {
  return {
    type: CLEAN_ACCOUNT_EXISTANCE,
  };
};

export const networkRegistration = (
  name,
  mobile,
  email,
  password,
  address,
  referral_by
) => {
  return async (dispatch) => {
    const response = await fetch(`${BASE_URL}network/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        mobile,
        email,
        password,
        address,
        referral_by,
      }),
    });

    if (!response.ok) {
      const result = await response.json();
      throw new Error(result.msg);
    }

    const result = await response.json();

    if (result.status) {
      dispatch({
        type: NETWORK_REGISTRATION,
        data: result.msg,
      });
    } else {
      throw new Error(result.msg);
    }
  };
};

export const registration = (
  name_of_entity,
  mobile,
  email,
  password,
  referral_by
) => {
  return async (dispatch) => {
    const response = await fetch(`${BASE_URL}registration`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name_of_entity,
        mobile,
        email,
        password,
        referral_by,
      }),
    });

    if (!response.ok) {
      const result = await response.json();
      throw new Error(result.msg);
    }

    const result = await response.json();

    if (result.status) {
      dispatch({
        type: REGISTRATION,
      });
      return result;
    } else {
      throw new Error(result.msg);
    }
  };
};

export const storeCity = (city) => {
  return {
    type: STORE_CITY,
    storeCity: city,
  };
};
export const storeSearch = (search) => {
  return {
    type: STORE_SEARCH,
    storeSearch: search,
  };
};

export const ddcRegistration = (
  name,
  email,
  mobile,
  pincode,
  state,
  district
) => {
  return async (dispatch) => {
    const response = await fetch(`${BASE_URL}ddc-registration`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        email,
        mobile,
        pincode,
        state,
        district,
      }),
    });

    if (!response.ok) {
      const result = await response.json();
      throw new Error(result.msg);
    }

    const result = await response.json();

    if (result.status) {
      dispatch({
        type: DDC_REGISTRATION,
      });
      return result;
    } else {
      throw new Error(result.msg);
    }
  };
};

export const msmeRegistration = (
  category_type,
  entity_type,
  company_name,
  entity_name,
  email,
  mobile,
  state,
  district
) => {
  return async (dispatch) => {
    const response = await fetch(`${BASE_URL}msme-registration`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        category_type,
        entity_type,
        company_name,
        entity_name,
        email,
        mobile,
        state,
        district,
      }),
    });

    if (!response.ok) {
      const result = await response.json();
      throw new Error(result.msg);
    }
    const result = await response.json();

    if (result.status) {
      dispatch({
        type: MSME_REGISTRATION,
      });
      return result;
    } else {
      throw new Error(result.msg);
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    await removeCookie(MSME_USER_TOKEN);
    await removeCookie(MSME_USER_TYPE);
    await removeCookie(MSME_USER_ID);
    dispatch({
      type: LOGOUT,
    });
  };
};

export const getCode = (canteenType) => {
  return async (dispatch) => {
    try {
      console.log(canteenType);
      const response = await fetch(
        `https://ardhsainikcanteen.in/api/running-store-code/${canteenType}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch Code.");
      }

      if (result) {
        dispatch({
          type: GET_CODE,
          data: result,
        });
      } else {
        throw new Error(result.message || "Failed to fetch Code.");
      }
    } catch (error) {
      console.error("Error fetching Code:", error.message);
      throw error; // Re-throw for further handling if needed
    }
  };
};
